import React from 'react';
import cls from './footer.module.scss';
import SelectorLang from './SelectorLang';
import json from '../../../package.json';
import Login from '../Login';
import imgHome from '../../img/logo_interdoc_FOOT.png';
import lngUrl from '../../helpers/lngUrl';

const Footer = () => {
    const date = (new Date().getYear() + 1900);
    return (<footer className={cls.footer_container}>
        <div>
            <div className={cls.wrapper}>
                <div className={cls.img}>
                    <img src={imgHome} alt='home' />
                </div>
                <div className={cls.block}>
                    INTERDOC {date} <SelectorLang />
                    <div className={cls.version}>
                        v. {json.version}
                    </div>
                </div>
            </div>
        </div>
        <div className={cls.form}>
            <Login language={lngUrl()} />
        </div>
    </footer>)
}

export default Footer;